import { useCallback, useMemo } from 'react';
import FJActionBrushEditCommon from '../../../redux/action/FJActionBrushEditCommon';
import FJMobileObjectEraseEditFooter from './FJMobileObjectEraseEditFooter';
import { useSelector, useDispatch } from 'react-redux';
import FJActionObjectErase from '../../../redux/action/FJActionObjectErase';
import FJActionCommon from '../../../redux/action/FJActionCommon';
import { FJViewCanvasSingleton, MOUSE_EVENT_TYPE } from '../../FJMainPreview/FJCreationEditPanel/js/FJViewCanvas';
import { setSliceDisableReset } from '../../../redux/slices/FJSliceBrushEditCommon';
import FJUtil from '../../../util/FJUtil';

const FJMobileObjectEraseEditFooterContainer = () => {
    const dispatch = useDispatch();
    const curBrushType = useSelector(state => state.brushEditCommon.curBrushType);
    const aiMaskActive = useSelector(state => state.brushEditCommon.aiMaskActive);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const _disableReset = useSelector(state => state.brushEditCommon.disableReset);
    const hasBrushUndo = useSelector(state => state.brushEditCommon.hasBrushUndo);
    const hasBrushRedo = useSelector(state => state.brushEditCommon.hasBrushRedo);
    const brashSize = useSelector(state => state.brushEditCommon.brushSize);

    const hasUndo = useMemo(() => hasBrushUndo && curBrushType !== MOUSE_EVENT_TYPE.NONE, [hasBrushUndo, curBrushType]);
    const hasRedo = useMemo(() => hasBrushRedo && curBrushType !== MOUSE_EVENT_TYPE.NONE, [hasBrushRedo, curBrushType]);

    const isDisabled = FJUtil.isGeneratingStatus(taskStatus);
    const disableReset = useMemo(
        () => _disableReset || curBrushType === MOUSE_EVENT_TYPE.NONE,
        [_disableReset, curBrushType],
    );
    const setBrushSize = useCallback(
        (value, type = 'input') => {
            if (isDisabled) return;

            dispatch(FJActionBrushEditCommon.updateBrushSizeAction(Math.round(value), type));
        },
        [dispatch, isDisabled],
    );

    const _uploadImage = useCallback(
        file => {
            dispatch(FJActionObjectErase.uploadImageAction(file));
        },
        [dispatch],
    );
    const onGenerate = useCallback(() => {
        dispatch(FJActionCommon.generateAction());
    }, [dispatch]);
    const undoHandler = useCallback(() => {
        const _undoFun = async () => {
            await FJViewCanvasSingleton.undo();
            dispatch(setSliceDisableReset(false));
            dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
        };

        if (hasUndo) {
            _undoFun();
        }
    }, [hasUndo, dispatch]);

    const redoHandler = useCallback(() => {
        const _redoFun = async () => {
            await FJViewCanvasSingleton.redo();
            dispatch(setSliceDisableReset(false));
            dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
        };

        if (hasRedo) {
            _redoFun();
        }
    }, [hasRedo, dispatch]);

    const resetHandler = useCallback(() => {
        if (disableReset) return;
        dispatch(FJActionBrushEditCommon.resetMaskAction());
        dispatch(FJActionBrushEditCommon.updateBrushUndoRedoAction());
    }, [disableReset, dispatch]);

    const onchangeBrushType = useCallback(
        value => {
            if (!aiMaskActive && value === MOUSE_EVENT_TYPE.QUICK_SELECTION) {
                dispatch(FJActionBrushEditCommon.setAiMaskActive(true));
            }
            dispatch(FJActionBrushEditCommon.setCurBrushTypeAction(value));
        },
        [dispatch, aiMaskActive],
    );

    return (
        <FJMobileObjectEraseEditFooter
            onGenerate={onGenerate}
            uploadImg={_uploadImage}
            curBrushType={curBrushType}
            setCurBrushType={onchangeBrushType}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            creditNumber={creditNumber}
            isProjectLoading={isProjectLoading}
            hasUndo={hasUndo}
            hasRedo={hasRedo}
            disableReset={disableReset}
            undoHandler={undoHandler}
            redoHandler={redoHandler}
            resetHandler={resetHandler}
            brashSize={brashSize}
            changeBrashSize={setBrushSize}
        />
    );
};

export default FJMobileObjectEraseEditFooterContainer;
